// ID UI catalogue.
// __I18N_PENDING__: values are not yet translated and fall back to English at runtime.
export default {
  'site.header.apartments': 'Apartemen dan Hotel',
  'site.currency': 'Mata uang',
  'site.language': 'Bahasa',
  'site.currencySelector': 'Pemilih mata uang',
  'site.languageSelector': 'Pemilih bahasa',
  'site.menu': 'Menu',
  'site.signIn': 'Masuk',
  'site.signOut': 'Keluar',
  'site.signOutConfirmTitle': '__I18N_PENDING__:Sign out?',
  'site.signOutConfirmBody': '__I18N_PENDING__:Are you sure you want to sign out?',
  'site.signOutStay': '__I18N_PENDING__:Stay signed in',
  'site.openMenu': 'Buka menu',
  'site.footer.copyright': 'Hak cipta dilindungi.',
  'site.footer.manageBooking': 'Kelola pemesanan Anda',
  'site.footer.terms': 'Syarat & Ketentuan',
  'site.footer.privacy': 'Kebijakan Privasi',
  'site.trust.bestPrice': 'Jaminan Harga Terbaik',
  'site.trust.bestPriceDesc': 'Dapatkan harga terbaik.',
  'site.trust.flexibleBooking': 'Pemesanan Fleksibel',
  'site.trust.flexibleBookingDesc': 'Mudah mengubah & membatalkan.',
  'site.trust.securePayments': 'Pembayaran Aman',
  'site.trust.securePaymentsDesc': 'Checkout tepercaya & aman.',
  'site.trust.localSupport': 'Dukungan Lokal',
  'site.trust.localSupportDesc': 'Kami siap membantu kapan saja.',
  'home.heroTitle': 'Temukan penginapan sempurna Anda',
  'home.inAustralia': 'di Australia',
  'home.heroSubtitle': 'Apartemen dan hotel untuk setiap jenis perjalanan',
  'home.errorLoading': 'Properti tidak dapat dimuat.',
  'home.noPropertiesTitle': 'Tidak ada properti yang tersedia saat ini.',
  'home.noPropertiesDescription': 'Coba cari destinasi untuk menjelajahi penginapan yang tersedia.',
  'home.exploreStays': 'Jelajahi penginapan',
  'home.property': 'properti',
  'home.property_one': 'properti',
  'home.property_other': 'properti',
  'home.properties': 'properti',
  'home.foundInAustralia': 'ditemukan di Australia',
  'search.errorLoading': 'Ketersediaan tidak dapat dimuat. Silakan coba lagi.',
  'search.noResults': 'Tidak ada properti yang cocok dengan kriteria pencarian Anda.',
  'search.mapFollow': 'Cari saat saya menggeser peta',
  'search.chooseLocationTitle': 'Pilih lokasi',
  'search.chooseLocationDescription': 'Pilih destinasi sebelum mencari penginapan yang tersedia.',
  'search.chooseDatesTitle': 'Pilih tanggal Anda',
  'search.pastCheckIn': 'Check-in tidak boleh di masa lalu.',
  'search.checkOutAfterCheckIn': 'Check-out harus setelah check-in.',
  'search.property': 'properti',
  'search.property_one': 'properti',
  'search.property_other': 'properti',
  'search.properties': 'properti',
  'search.found': 'ditemukan',
  'widget.where': 'Ke mana',
  'widget.location': 'Lokasi',
  'widget.checkInOut': 'Check-in / Check-out',
  'widget.guests': 'Tamu',
  'widget.rooms': 'Kamar',
  'widget.promoCode': 'Kode Promo',
  'widget.promoPlaceholderCompact': 'Tambah kode (opsional)',
  'widget.promoPlaceholder': 'Opsional',
  'widget.search': 'Cari',
  'widget.update': '__I18N_PENDING__:Update',
  'widget.adult': 'Dewasa',
  'widget.adults': 'Dewasa',
  'widget.child': 'Anak',
  'widget.children': 'Anak',
  'widget.decreaseAdults': 'Kurangi dewasa',
  'widget.increaseAdults': 'Tambah dewasa',
  'widget.decreaseChildren': 'Kurangi anak',
  'widget.increaseChildren': 'Tambah anak',
  'widget.room': 'Kamar',
  'widget.adultOption': '{count} Dewasa',
  'widget.adultOption_one': '{count} Dewasa',
  'widget.adultOption_other': '{count} Dewasa',
  'widget.childOption': '{count} Anak',
  'widget.childOption_one': '{count} Anak',
  'widget.childOption_other': '{count} Anak',
  'widget.roomOption': '{count} Kamar',
  'widget.roomOption_one': '{count} Kamar',
  'widget.roomOption_other': '{count} Kamar',
  'widget.guestCount': '__I18N_PENDING__:{count} guests',
  'widget.guestCount_one': '__I18N_PENDING__:{count} guest',
  'widget.guestCount_other': '__I18N_PENDING__:{count} guests',
  'widget.roomCount': '__I18N_PENDING__:{count} rooms',
  'widget.roomCount_one': '__I18N_PENDING__:{count} room',
  'widget.roomCount_other': '__I18N_PENDING__:{count} rooms',
  'widget.locationError': 'Lokasi tidak dapat dimuat. Silakan coba lagi.',
  'widget.searchAria': 'Cari ketersediaan',
  'widget.dateErrorRequired': 'Silakan pilih tanggal check-in dan check-out.',
  'widget.dateErrorPast': 'Check-in tidak boleh di masa lalu.',
  'widget.dateErrorRange': 'Check-out harus setelah check-in.',
  'widget.dateRange.placeholder': 'Pilih tanggal check-in & check-out',
  'widget.dateRange.selectCheckout': 'Pilih check-out',
  'widget.dateRange.aria.checkIn': 'Check-in',
  'widget.dateRange.aria.checkOut': 'Check-out',
  'widget.dateRange.aria.picker': 'Pemilih rentang tanggal check-in / check-out',
  'widget.dateRange.previousMonth': 'Bulan sebelumnya',
  'widget.dateRange.nextMonth': 'Bulan berikutnya',
  'widget.dateRange.selectCheckIn': 'Pilih tanggal check-in',
  'widget.dateRange.selectCheckOut': 'Pilih tanggal check-out',
  'widget.dateRange.resetToday': 'Atur Ulang ke Hari Ini',
  'widget.dateRange.done': 'Selesai',
  'property.heroAlt': 'Hero properti',
  'property.fallbackName': 'Properti pilihan dari {site}',
  'property.chooseRoom': 'Pilih kamar Anda',
  'property.filterBy': 'Filter berdasarkan:',
  'property.filterAll': 'Semua Kamar',
  'property.filterStudios': 'Studio',
  'property.filter1Bed': '1 Kamar Tidur',
  'property.filter2Bed': '2 Kamar Tidur',
  'property.filterApartments': 'Apartemen',
  'property.sortBy': 'Urutkan berdasarkan:',
  'property.sortRecommended': 'Direkomendasikan',
  'property.sortPriceLow': 'Harga: Rendah ke Tinggi',
  'property.sortPriceHigh': 'Harga: Tinggi ke Rendah',
  'property.errorLoading': 'Ketersediaan tidak dapat dimuat. Silakan coba lagi.',
  'property.noRooms': 'Tidak ada kamar yang tersedia',
  'property.noRoomsDescription': 'Coba tanggal atau okupasi lain.',
  'property.totalForNights': 'Total untuk {nights} malam',
  'property.perNight': 'per malam',
  'property.night': 'malam',
  'property.night_one': 'malam',
  'property.night_other': 'malam',
  'property.nights': 'malam',
  'property.freeCancellation': 'Pembatalan gratis',
  'property.selectRoom': 'Pilih kamar',
  'property.selected': 'Terpilih',
  'property.continue': 'Lanjutkan',
  'property.previousPhoto': 'Foto sebelumnya',
  'property.nextPhoto': 'Foto berikutnya',
  'property.addToWishlist': 'Tambah ke wishlist',
  'property.popularChoice': 'Pilihan populer',
  'property.showMore': 'Tampilkan lebih banyak',
  'property.showLess': 'Tampilkan lebih sedikit',
  'property.maxOccupancy': 'Okupasi Maks:',
  'property.size': 'Ukuran:',
  'property.bedType': 'Tipe Tempat Tidur:',
  'property.roomAmenities': 'Fasilitas Kamar',
  'property.showMoreAmenities': '+{count} lainnya',
  'property.guests': 'Tamu',
  'property.adults': 'Dewasa',
  'property.children': 'Anak-anak',
  'property.onlyRoomsLeft': 'Hanya tersisa {count} kamar',
  'property.onlyRoomsLeft_one': 'Hanya tersisa {count} kamar',
  'property.onlyRoomsLeft_other': 'Hanya tersisa {count} kamar',
  'property.lastBookedMinutes': 'Terakhir dipesan {count} menit yang lalu',
  'property.lastBookedMinutes_one': 'Terakhir dipesan {count} menit yang lalu',
  'property.lastBookedMinutes_other': 'Terakhir dipesan {count} menit yang lalu',
  'property.lastBookedHours': 'Terakhir dipesan {count} jam yang lalu',
  'property.lastBookedHours_one': 'Terakhir dipesan {count} jam yang lalu',
  'property.lastBookedHours_other': 'Terakhir dipesan {count} jam yang lalu',
  'property.lastBookedDays': 'Terakhir dipesan {count} hari yang lalu',
  'property.lastBookedDays_one': 'Terakhir dipesan {count} hari yang lalu',
  'property.lastBookedDays_other': 'Terakhir dipesan {count} hari yang lalu',
  'property.checkInTime': 'Check-in {time}',
  'property.checkOutTime': 'Check-out {time}',
  'property.compare': 'Bandingkan',
  'property.taxesIncluded': 'per malam termasuk pajak & biaya',
  'property.chooseRate': 'Pilih tarif Anda',
  'property.yourSelection': 'Pilihan Anda',
  'property.aboutRoom': 'Tentang kamar ini',
  'property.roomDetails': 'Detail kamar',
  'property.selectedProperty': '__I18N_PENDING__:Selected property by {site}',
  'property.backToRooms': 'Kembali ke kamar',
  'property.standardRate': 'Tarif Standar',
  'property.noPromotion': 'Tidak ada promosi untuk tarif ini.',
  'property.youSave': 'Anda hemat ({percent}%) - {amount}',
  'property.inclusions': 'Termasuk:',
  'property.viewAllPhotos': 'Lihat semua foto',
  'property.seeOnMap': 'Lihat di peta',
  'room.perNight': 'malam',
  'room.sleeps': 'Kapasitas',
  'room.thumbnailAlt': '__I18N_PENDING__:Thumbnail',
  'room.available': 'tersedia',
  'room.select': 'Pilih',
  'room.selected': 'Terpilih',
  'card.viewAvailability': 'Lihat ketersediaan',
  'card.from': 'Dari',
  'card.night': 'malam',
  'card.checkAvailability': 'Periksa Ketersediaan',
  'card.saveToFavourites': 'Simpan ke favorit',
  'card.ratingExcellent': 'Luar biasa',
  'card.ratingVeryGood': 'Sangat baik',
  'card.ratingGood': 'Baik',
  'card.ratingGuest': 'Penilaian tamu',
  'guest.stepChooseRoom': 'Pilih Kamar',
  'guest.stepGuestDetails': 'Detail Tamu',
  'guest.stepPayment': 'Pembayaran',
  'guest.stepConfirmation': 'Konfirmasi',
  'guest.title': 'Masukkan Detail Tamu',
  'guest.subtitle': 'Silakan berikan informasi Anda.',
  'guest.firstName': 'Nama depan',
  'guest.lastName': 'Nama belakang',
  'guest.email': 'Email',
  'guest.emailHint': 'Konfirmasi pemesanan akan dikirim ke email ini.',
  'guest.country': 'Negara',
  'guest.selectCountry': 'Pilih negara',
  'guest.searchCountry': 'Cari negara…',
  'guest.loadingCountries': 'Memuat negara…',
  'guest.loadingSuburbs': '__I18N_PENDING__:Loading suburbs…',
  'guest.noSuburbsFound': '__I18N_PENDING__:No suburbs found',
  'guest.selectedSuburb': '__I18N_PENDING__:Selected: {suburb}',
  'guest.postalCode': 'Kode pos',
  'guest.phone': 'Nomor telepon',
  'guest.phoneCountryCode': '__I18N_PENDING__:Country code',
  'guest.phonePlaceholder': 'Masukkan nomor telepon',
  'guest.address': 'Alamat',
  'guest.city': 'Kota',
  'guest.specialRequests': 'Permintaan khusus (opsional)',
  'guest.specialRequestsPlaceholder': 'Ada permintaan khusus?',
  'guest.termsPrefix': 'Dengan menyelesaikan pemesanan ini, saya menyetujui',
  'guest.terms': 'Syarat & Ketentuan',
  'guest.termsAnd': 'dan',
  'guest.privacy': 'Kebijakan Privasi',
  'guest.termsSuffix': ', dan saya menerima kondisi pemesanan.',
  'guest.marketingOptOut': 'Saya tidak ingin menerima pesan pemasaran.',
  'guest.cardVerify':
    'Verifikasi kartu sementara 1 {currency} akan ditempatkan. Anda belum akan dikenakan biaya sekarang.',
  'guest.chargeNow': '__I18N_PENDING__:Your card will be charged {amount} now.',
  'guest.payOnArrival': 'Pembayaran akan diambil di properti.',
  'guest.noRoomsSelected': 'Tidak ada kamar yang dipilih.',
  'guest.noPropertySelected': 'Tidak ada properti yang dipilih.',
  'guest.paymentStillLoading': 'Opsi pembayaran masih memuat. Silakan coba lagi sebentar.',
  'guest.submitProcessing': 'Memproses…',
  'guest.submitVerifyCard': 'Verifikasi kartu dan konfirmasi pemesanan',
  'guest.submitConfirm': 'Konfirmasi pemesanan',
  'checkout.backToRooms': '__I18N_PENDING__:Back to room selection',
  'checkout.bookingSummary': '__I18N_PENDING__:Your booking summary',
  'checkout.noRooms': '__I18N_PENDING__:No rooms in this booking — add one below.',
  'checkout.edit': '__I18N_PENDING__:Edit',
  'checkout.remove': '__I18N_PENDING__:Remove',
  'checkout.removeTitle': '__I18N_PENDING__:Remove this room?',
  'checkout.removeBody':
    "__I18N_PENDING__:{room} will be removed from your booking. This action can't be undone — you'll need to select the room again to add it back.",
  'checkout.removeCancel': '__I18N_PENDING__:Cancel',
  'checkout.removeConfirm': '__I18N_PENDING__:Remove room',
  'checkout.duration': '__I18N_PENDING__:Duration of stay',
  'checkout.occupancy': '__I18N_PENDING__:Occupancy',
  'checkout.occupancyValue': '__I18N_PENDING__:{adults} Adults, {children} Children',
  'checkout.ratePlan': '__I18N_PENDING__:Rate Plan',
  'checkout.policies': '__I18N_PENDING__:Cancellation & Payment Policies',
  'checkout.roomRequests': '__I18N_PENDING__:Special requests (optional)',
  'checkout.roomRequestsPlaceholder':
    '__I18N_PENDING__:Arrival time, accessibility needs or anything else for this room',
  'checkout.roomSubTotal': '__I18N_PENDING__:Sub Total',
  'checkout.accommodationFees':
    '__I18N_PENDING__:Accommodation fees • {rooms} room(s) · {nights} nights',
  'checkout.taxesAndFees': '__I18N_PENDING__:Taxes & fees',
  'checkout.memberSavings': '__I18N_PENDING__:Member savings',
  'checkout.promotionSavings': '__I18N_PENDING__:Savings',
  'checkout.total': '__I18N_PENDING__:Total',
  'checkout.totalCaption': '__I18N_PENDING__:Includes taxes & fees',
  'checkout.propertyCurrencyTitle':
    '__I18N_PENDING__:Estimated total in property currency ({currency})',
  'checkout.propertyCurrencyNote':
    "__I18N_PENDING__:Prices are shown in {currency} for your convenience, converted at today's exchange rate. Your payment will be processed in the property's currency ({propertyCurrency}), so the final amount on your statement may vary slightly with exchange-rate movements on the day of payment.",
  'checkout.addAnotherRoom': '__I18N_PENDING__:Add another room',
  'checkout.memberTitle': '__I18N_PENDING__:Join as a member now — membership is free',
  'checkout.memberTitleWithSaving':
    '__I18N_PENDING__:Join as a member now — save {amount} on this booking',
  'checkout.memberBody': '__I18N_PENDING__:Member discounts apply before you pay.',
  'checkout.memberJoin': '__I18N_PENDING__:Join free',
  'checkout.memberSignIn': '__I18N_PENDING__:Sign in',
  'checkout.memberJoinInline': '__I18N_PENDING__:Join as a member using the details above',
  'checkout.memberJoinInlineHint':
    '__I18N_PENDING__:Get access to exclusive member benefits and offers.',
  'checkout.memberTotal': '__I18N_PENDING__:Member total',
  'checkout.memberSaveCaption': '__I18N_PENDING__:You save {amount} · includes taxes & fees',
  'checkout.nonMemberTotalCaption': '__I18N_PENDING__:Non-member total · includes taxes & fees',
  'checkout.stayConnected':
    '__I18N_PENDING__:Stay connected with {site} — get exclusive offers, deals and newsletters. Opt out anytime.',
  'checkout.proceedToPayment': '__I18N_PENDING__:Proceed to payment',
  'checkout.processing': '__I18N_PENDING__:Processing your booking…',
  'checkout.processingDoNotClose':
    '__I18N_PENDING__:Processing your booking — please do not close this window until your booking is confirmed.',
  'checkout.doNotClose':
    '__I18N_PENDING__:Please do not close your browser until your booking is confirmed.',
  'checkout.applyingMemberRates': '__I18N_PENDING__:Applying member rates to your stay…',
  'checkout.loadingProfile': '__I18N_PENDING__:Loading your member details…',
  'checkout.preparingPayment': '__I18N_PENDING__:Preparing secure payment…',
  'checkout.termsHint':
    '__I18N_PENDING__:The button becomes active once you accept the Terms & Conditions.',
  'checkout.gatewayRedirect':
    "__I18N_PENDING__:You'll be redirected to {gateway}, our secure payment provider, to complete your booking.",
  'checkout.securePayment':
    '__I18N_PENDING__:Your payment is handled by our secure payment provider.',
  'checkout.stayDates': '__I18N_PENDING__:{checkIn} – {checkOut} • {nights} nights',
  'payment.title': 'Pembayaran',
  'payment.method': 'Metode pembayaran',
  'payment.cardDetailsHint':
    'Masukkan detail kartu Anda dengan aman di bawah. Detail kartu Anda ditokenisasi dan tidak pernah menyentuh server kami.',
  'payment.loadingForm': 'Memuat formulir pembayaran…',
  'payment.formUnavailable': 'Formulir pembayaran tidak tersedia.',
  'payment.acceptTerms': 'Saya menerima syarat dan ketentuan serta kebijakan pembatalan.',
  'payment.payNow': 'Bayar sekarang',
  'payment.processing': 'Memproses…',
  'payment.noRoomsSelected': 'Tidak ada kamar yang dipilih.',
  'payment.redirecting': 'Mengalihkan ke halaman pembayaran aman…',
  'payment.notConfigured': 'Quickstream tidak dikonfigurasi untuk properti ini.',
  'payment.noScript':
    'Layanan pembayaran Quickstream tidak dapat dimuat. Silakan muat ulang halaman.',
  'payment.formNotLoaded': 'Formulir pembayaran tidak dimuat. Silakan muat ulang halaman.',
  'payment.cardDetails': 'Pembayaran gagal. Silakan periksa detail kartu Anda.',
  'payment.tokenizationFailed': 'Tokenisasi kartu gagal. Silakan coba lagi.',
  'payment.failed': 'Pembayaran gagal.',
  'payment.statusResult': 'Status pembayaran: {status}. Silakan coba lagi.',
  'confirmation.loading': 'Memuat pemesanan Anda…',
  'confirmation.notFound':
    'Pemesanan tidak ditemukan. Periksa referensi pemesanan Anda dan coba lagi.',
  'confirmation.errorGeneric': 'Pemesanan Anda tidak dapat dikonfirmasi. Silakan hubungi dukungan.',
  'confirmation.errorLoadDetails': 'Tidak dapat memuat detail reservasi.',
  'confirmation.couldNotComplete': 'Kami tidak dapat menyelesaikan pembayaran Anda',
  'confirmation.startNew': 'Mulai pemesanan baru',
  'confirmation.tryPaymentAgain': '__I18N_PENDING__:Try payment again',
  'confirmation.paymentNotFound': 'Sesi pembayaran tidak ditemukan. Silakan hubungi dukungan.',
  'confirmation.paymentStateInvalid':
    'Pembayaran tidak dalam keadaan valid untuk diselesaikan. Silakan mulai lagi.',
  'confirmation.paymentFailedDeclined':
    'Pembayaran Anda tidak dapat diselesaikan. Silakan periksa detail kartu Anda dan coba lagi, atau gunakan metode pembayaran lain.',
  'confirmation.paymentTimeout': 'Pembayaran terlalu lama. Silakan coba lagi.',
  'confirmation.paymentGatewayUnavailable':
    'Sistem pembayaran sedang tidak tersedia. Silakan coba lagi sebentar.',
  'confirmation.paymentUnknown': 'Pembayaran tidak dapat dikonfirmasi: {message}.',
  'confirmation.paymentGenericError':
    'Pembayaran tidak dapat dikonfirmasi. Silakan coba lagi atau hubungi dukungan.',
  'summary.title': 'Ringkasan Pemesanan Anda',
  'summary.yourBooking': 'Ringkasan Pemesanan Anda',
  'summary.noRoomsSelected': 'Belum ada kamar yang dipilih.',
  'summary.checkIn': 'CHECK-IN',
  'summary.checkOut': 'CHECK-OUT',
  'summary.lengthOfStay': 'Lama menginap',
  'summary.guests': 'Tamu',
  'summary.nights': '{nights} malam',
  'summary.nights_one': '{nights} malam',
  'summary.nights_other': '{nights} malam',
  'summary.totalForNights': 'Total untuk {nights} malam',
  'summary.includingTaxes': 'Termasuk pajak & biaya',
  'summary.discount': 'Hemat {amount}',
  'summary.checkInFrom': '__I18N_PENDING__:From {time}',
  'summary.checkOutUntil': '__I18N_PENDING__:Until {time}',
  'summary.cancellationUntil': '__I18N_PENDING__:until {date}',
  'detail.confirmed': 'Pemesanan dikonfirmasi!',
  'detail.received': 'Pemesanan diterima',
  'detail.referenceIntro': 'Referensi pemesanan Anda adalah',
  'detail.reservationId': 'Id reservasi:',
  'detail.processing':
    'Pemesanan Anda sedang diproses. Anda akan menerima email konfirmasi setelah pembayaran dikonfirmasi.',
  'detail.guest': 'Tamu',
  'detail.rooms': 'Kamar',
  'detail.night': 'malam',
  'detail.nights': 'malam',
  'detail.adult': 'dewasa',
  'detail.adults': 'dewasa',
  'detail.child': 'anak',
  'detail.infant': 'bayi',
  'detail.priceBreakdown': 'Rincian harga',
  'detail.subtotal': 'Subtotal',
  'detail.taxes': 'Pajak',
  'detail.fees': 'Biaya',
  'detail.discounts': 'Diskon',
  'detail.surcharge': 'Biaya tambahan kartu',
  'detail.grandTotal': 'Total akhir',
  'priceBreakdown.roomSubtotal': 'Subtotal kamar',
  'priceBreakdown.total': 'Total',
  'detail.deposit': 'Deposit',
  'detail.depositDueBy': 'jatuh tempo pada',
  'detail.arrival': 'kedatangan',
  'detail.specialRequests': 'Permintaan khusus',
  'detail.backToHome': 'Kembali ke beranda',
  'detail.confirmationSentTo': '__I18N_PENDING__:A confirmation email has been sent to',
  'detail.bookingReference': '__I18N_PENDING__:Booking reference',
  'detail.address': '__I18N_PENDING__:Address',
  'detail.guestDetails': '__I18N_PENDING__:Guest details',
  'detail.name': '__I18N_PENDING__:Name',
  'detail.email': '__I18N_PENDING__:Email',
  'detail.phone': '__I18N_PENDING__:Mobile number',
  'detail.status': '__I18N_PENDING__:Status',
  'detail.card': '__I18N_PENDING__:Card',
  'detail.paidInFull': '__I18N_PENDING__:Paid in full',
  'detail.partiallyPaid': '__I18N_PENDING__:Partially paid',
  'detail.paidOnline': '__I18N_PENDING__:Paid online',
  'detail.dueAtProperty': '__I18N_PENDING__:Due at property',
  'detail.bookedOn': '__I18N_PENDING__:Booked on',
  'detail.roomTotal': '__I18N_PENDING__:Room total',
  'detail.roomsCount': '__I18N_PENDING__:Rooms ({count})',
  'detail.yourRoom': '__I18N_PENDING__:Your room',
  'detail.roomNumber': '__I18N_PENDING__:Room {number}',
  'detail.priceSummary': '__I18N_PENDING__:Price summary',
  'detail.chargedInPropertyCurrency': '__I18N_PENDING__:Charged in property currency ({currency})',
  'detail.totalPaid': '__I18N_PENDING__:Total paid',
  'detail.plansChanged': '__I18N_PENDING__:Plans changed?',
  'detail.plansChangedBody':
    '__I18N_PENDING__:Contact the property directly, quoting your booking reference {reference}.',
  'detail.printConfirmation': '__I18N_PENDING__:Print confirmation',
  'detail.questions':
    '__I18N_PENDING__:Questions? Reply to your confirmation email or contact the property directly.',
  'shared.retry': 'Coba lagi',
  'shared.close': 'Tutup',
  'shared.back': 'Kembali',
  'shared.previous': 'Sebelumnya',
  'shared.next': 'Berikutnya',
  'validation.firstNameRequired': 'Nama depan wajib diisi',
  'validation.lastNameRequired': 'Nama belakang wajib diisi',
  'validation.emailRequired': 'Email yang valid wajib diisi',
  'validation.phoneRequired': 'Nomor telepon wajib diisi',
  'validation.addressRequired': 'Alamat wajib diisi',
  'validation.cityRequired': 'Kota wajib diisi',
  'validation.countryRequired': 'Negara wajib diisi',
  'validation.postalCodeRequired': 'Kode pos wajib diisi',
  'error.pmsUnavailable':
    'Maaf, kamar ini tidak lagi tersedia untuk tanggal yang Anda pilih. Silakan kembali dan pilih tanggal atau kamar lain.',
  'error.pmsSyncError':
    'Kami tidak dapat terhubung dengan sistem properti. Silakan coba lagi sebentar.',
  'error.paymentNotConfigured':
    'Pembayaran tidak dikonfigurasi untuk properti ini. Silakan pilih properti lain atau hubungi dukungan.',
  'error.paymentStartFailed': 'Terjadi kesalahan saat memulai pembayaran. Silakan coba lagi.',
  'error.bookingFailed': 'Pemesanan gagal. Silakan coba lagi.',
  'error.quoteAlreadyConverted':
    '__I18N_PENDING__:This rate has already been booked. Please select the room and rate again.',
  'error.quoteRequiresMember':
    '__I18N_PENDING__:A selected rate is a member rate. Sign in to keep it, or remove the room and pick it again.',
  'site.title.default': 'Pesan penginapan Anda',
  'site.title.suffix': 'Apartemen dan Hotel',
  'site.title.home': 'Beranda',
  'site.title.search': 'Cari',
  'site.title.property': 'Properti',
  'site.title.room': 'Kamar',
  'site.title.guestDetails': 'Detail Tamu',
  'site.title.payment': 'Pembayaran',
  'site.title.confirmation': 'Pemesanan Dikonfirmasi',
  'site.title.bookingLookup': 'Temukan pemesanan Anda',
  'site.title.bookingDetails': 'Detail pemesanan',
  'site.title.cancellation': 'Batalkan pemesanan',
  'site.title.reservationDetail': 'Detail reservasi',
  'site.title.signIn': 'Masuk',
  'site.title.signUp': 'Daftar',
  'site.title.notFound': 'Halaman tidak ditemukan',
  'notFound.title': 'Halaman tidak ditemukan',
  'notFound.message': 'Halaman yang Anda cari tidak ada.',
  'notFound.backHome': 'Kembali ke beranda',
  'home.heroAlt': 'Pemandangan kota Australia',
  'home.featuredProperties': 'Properti unggulan',
  'home.popularDestinations': 'Destinasi populer',
  'common.reviews': '{count} ulasan',
  'common.reviews_one': '{count} ulasan',
  'common.reviews_other': '{count} ulasan',
  'common.loading': 'Memuat',
  'common.pleaseWait': '__I18N_PENDING__:Please wait while we load your results',
  'common.of': 'dari',
  'common.select': 'Pilih…',
  'common.search': 'Cari…',
  'common.selectLocation': 'Pilih lokasi',
  'location.propertyCount': '__I18N_PENDING__:{count} properties',
  'location.propertyCount_one': '__I18N_PENDING__:{count} property',
  'location.propertyCount_other': '__I18N_PENDING__:{count} properties',
  'location.roomsAvailable': '__I18N_PENDING__:{count} rooms available',
  'location.roomsAvailable_one': '__I18N_PENDING__:{count} room available',
  'location.roomsAvailable_other': '__I18N_PENDING__:{count} rooms available',
  'map.suburb.newstead': '__I18N_PENDING__:Newstead',
  'map.suburb.fortitudeValley': '__I18N_PENDING__:Fortitude Valley',
  'map.suburb.paddington': '__I18N_PENDING__:Paddington',
  'map.suburb.bardon': '__I18N_PENDING__:Bardon',
  'map.suburb.brisbane': '__I18N_PENDING__:Brisbane',
  'map.suburb.southBrisbane': '__I18N_PENDING__:South Brisbane',
  'map.suburb.kangarooPoint': '__I18N_PENDING__:Kangaroo Point',
  'map.suburb.stLucia': '__I18N_PENDING__:St Lucia',
  'map.suburb.moorooka': '__I18N_PENDING__:Moorooka',
  'map.suburb.annerley': '__I18N_PENDING__:Annerley',
  'map.suburb.mtGravatt': '__I18N_PENDING__:Mt Gravatt',
  'common.noOptions': 'Tidak ada opsi tersedia',
  'common.code': 'Kode',
  'common.searchCode': 'Cari kode…',
  'filter.title': 'Filter',
  'filter.price': 'Harga',
  'filter.priceMinimum': 'Minimum',
  'filter.priceMaximum': 'Maksimum',
  'filter.priceMinPlaceholder': '$0',
  'filter.priceMaxPlaceholder': '$500+',
  'filter.propertyType': 'Tipe Properti',
  'filter.propertyType.hotel': 'Hotel',
  'filter.propertyType.apartment': 'Apartemen',
  'filter.propertyType.resort': 'Resor',
  'filter.amenities': 'Fasilitas',
  'filter.amenity.pool': 'Kolam renang',
  'filter.amenity.parking': 'Parkir',
  'filter.amenity.breakfast': 'Sarapan termasuk',
  'filter.rating': 'Penilaian',
  'filter.rating.any': 'Penilaian apa saja',
  'filter.rating.5': '5 bintang',
  'filter.rating.4': '4 bintang ke atas',
  'filter.rating.3': '3 bintang ke atas',
  'filter.more': 'Lebih banyak',
  'filter.more.freeCancellation': 'Pembatalan gratis',
  'filter.more.payAtProperty': 'Bayar di properti',
  'filter.clear': 'Hapus',
  'filter.apply': 'Terapkan filter',
  'card.reviews_one': 'ulasan',
  'card.reviews_other': 'ulasan',
  'card.imageCounter': '{current} / {total}',
  'card.showMore': '__I18N_PENDING__:show more',
  'card.showLess': '__I18N_PENDING__:show less',
  'widget.childrenAgeHint': 'Usia 0 - 12',
  'auth.orContinueWith': 'Atau lanjutkan dengan',
  'auth.signIn.title': 'Masuk ke akun Anda',
  'auth.signIn.subtitle':
    'Selamat datang kembali! Masuk untuk mengelola pemesanan Anda, melihat penginapan, dan mengakses penawaran eksklusif.',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Masukkan alamat email Anda',
  'auth.emailRequired': 'Email wajib diisi.',
  'auth.emailInvalid': 'Silakan masukkan alamat email yang valid.',
  'auth.password': 'Kata sandi',
  'auth.passwordPlaceholder': 'Masukkan kata sandi Anda',
  'auth.createPasswordPlaceholder': 'Buat kata sandi',
  'auth.passwordRequired': 'Kata sandi wajib diisi.',
  'auth.passwordMinLength': 'Kata sandi minimal {min} karakter.',
  'auth.passwordPattern': 'Kata sandi harus menyertakan huruf dan angka.',
  'auth.passwordHint': 'Gunakan minimal {min} karakter dengan kombinasi huruf, angka, dan simbol.',
  'auth.showPassword': 'Tampilkan kata sandi',
  'auth.hidePassword': 'Sembunyikan kata sandi',
  'auth.keepSignedIn': 'Biarkan saya tetap masuk',
  'auth.forgotPassword': 'Lupa kata sandi?',
  'auth.forgot.title': '__I18N_PENDING__:Reset your password',
  'auth.forgot.subtitle':
    '__I18N_PENDING__:Enter the email address on your account and we will send you a link to choose a new password.',
  'auth.forgot.submit': '__I18N_PENDING__:Send reset link',
  'auth.forgot.sending': '__I18N_PENDING__:Sending...',
  'auth.forgot.success':
    '__I18N_PENDING__:If an account exists for that email, a reset link is on its way. Check your inbox and spam folder.',
  'auth.forgot.backToSignIn': '__I18N_PENDING__:Back to sign in',
  'auth.reset.title': '__I18N_PENDING__:Choose a new password',
  'auth.reset.subtitle': '__I18N_PENDING__:Enter a new password for your account.',
  'auth.reset.submit': '__I18N_PENDING__:Reset password',
  'auth.reset.saving': '__I18N_PENDING__:Resetting...',
  'auth.reset.success':
    '__I18N_PENDING__:Your password has been updated. You can sign in with it now.',
  'auth.reset.missingToken':
    '__I18N_PENDING__:This reset link is missing its token. Request a new link instead.',
  'auth.reset.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.title': '__I18N_PENDING__:Verify your email',
  'auth.verify.verifying': '__I18N_PENDING__:Verifying your email address…',
  'auth.verify.success':
    '__I18N_PENDING__:Your email address has been verified. You can sign in now.',
  'auth.verify.error': '__I18N_PENDING__:We could not verify this link.',
  'auth.verify.missingToken':
    '__I18N_PENDING__:This verification link is missing its token. Sign in to request a new link.',
  'auth.verify.errorHint':
    '__I18N_PENDING__:The link may have expired. Sign in to request a new verification email.',
  'auth.verify.goToSignIn': '__I18N_PENDING__:Go to sign in',
  'auth.verify.resend': '__I18N_PENDING__:Resend verification email',
  'auth.verify.sending': '__I18N_PENDING__:Sending email…',
  'auth.verify.resent':
    '__I18N_PENDING__:Verification email sent. Please check your inbox and spam folder.',
  'auth.signIn': 'Masuk',
  'auth.signingIn': 'Sedang masuk...',
  'auth.signInError': 'Gagal masuk. Silakan coba lagi.',
  'auth.googleError': 'Gagal masuk dengan Google.',
  'auth.noAccount': 'Belum punya akun?',
  'auth.createAccount': 'Buat akun',
  'auth.signUp.title': 'Buat akun Anda',
  'auth.signUp.subtitle':
    'Bergabung dengan {site} untuk mengelola pemesanan Anda, menyimpan properti favorit, dan mendapatkan penawaran eksklusif.',
  'auth.firstName': 'Nama depan',
  'auth.firstNamePlaceholder': 'Masukkan nama depan Anda',
  'auth.firstNameRequired': 'Nama depan wajib diisi.',
  'auth.lastName': 'Nama belakang',
  'auth.lastNamePlaceholder': 'Masukkan nama belakang Anda',
  'auth.lastNameRequired': 'Nama belakang wajib diisi.',
  'auth.mobile': 'Nomor ponsel',
  'auth.mobilePlaceholder': 'Masukkan nomor ponsel Anda',
  'auth.dialingCode': 'Kode panggilan negara',
  'auth.mobileRequired': 'Nomor ponsel wajib diisi.',
  'auth.mobileInvalid': 'Silakan masukkan nomor ponsel yang valid.',
  'auth.confirmPassword': 'Konfirmasi kata sandi',
  'auth.confirmPasswordPlaceholder': 'Konfirmasi kata sandi Anda',
  'auth.termsAgree': 'Saya menyetujui',
  'auth.termsRequired': 'Anda harus menyetujui Syarat & Ketentuan dan Kebijakan Privasi.',
  'auth.marketingConsent':
    'Saya ingin menerima penawaran eksklusif dan inspirasi perjalanan dari {site}',
  'auth.signUpError': 'Tidak dapat membuat akun. Silakan coba lagi.',
  'auth.signUp': 'Daftar',
  'auth.creatingAccount': 'Membuat akun...',
  'auth.createAccountButton': 'Buat akun',
  'auth.alreadyHaveAccount': 'Sudah punya akun?',
  'auth.passwordMismatch': 'Kata sandi tidak cocok.',
  'pricing.title': 'Ringkasan harga',
  'pricing.noRoomsSelected': 'Tidak ada kamar yang dipilih. Silakan kembali dan pilih kamar.',
  'pricing.backToAvailability': 'Kembali ke ketersediaan',
  'pricing.continue': 'Lanjutkan ke detail tamu',
  'property.youSavePercent': 'Anda hemat ({percent}%)',
  'property.includingTaxesFees': '(termasuk pajak & biaya)',
  'map.zoomIn': 'Perbesar',
  'map.zoomOut': 'Perkecil',
  'map.viewFullMap': 'Lihat di peta penuh',
  'booking.progress': 'Progres pemesanan',
  'reservationDetail.resetAria': 'Atur ulang status pemesanan',
  'bookingLookup.title': 'Temukan pemesanan Anda',
  'bookingLookup.description':
    'Masukkan nomor referensi pemesanan dan email Anda untuk melihat, mengubah, atau membatalkan reservasi.',
  'bookingLookup.bookingReference': 'Nomor referensi pemesanan',
  'bookingLookup.placeholder': 'mis. SYD-260815-0001',
  'bookingLookup.lookingUp': 'Mencari…',
  'bookingLookup.findBooking': 'Temukan pemesanan',
  'bookingLookup.notFound':
    'Pemesanan tidak ditemukan. Coba BK-2026-001, alex.morgan@example.com, dan Morgan.',
  'cancellation.title': 'Batalkan pemesanan',
  'cancellation.property': 'Properti',
  'cancellation.details': 'Detail pembatalan',
  'cancellation.penalty': 'Denda pembatalan',
  'cancellation.refund': 'Jumlah pengembalian',
  'cancellation.totalPaid': 'Total dibayar:',
  'cancellation.reasonLabel': 'Alasan pembatalan (opsional)',
  'cancellation.understand': 'Saya memahami tindakan ini tidak dapat dibatalkan.',
  'cancellation.cancelledDemo':
    'Pemesanan Anda telah dibatalkan dalam demo UI ini. Jumlah pengembalian: {{refundAmount}}.',
  'cancellation.confirm': 'Konfirmasi pembatalan',
  'cancellation.notFound': 'Pemesanan tidak ditemukan.',
  'bookingDetails.title': 'Detail pemesanan',
  'bookingDetails.notFound': 'Pemesanan tidak ditemukan.',
  'bookingDetails.checkIn': 'Check-in:',
  'bookingDetails.checkOut': 'Check-out:',
  'bookingDetails.rooms': 'Kamar',
  'bookingDetails.guest': 'Tamu',
  'bookingDetails.freeCancellationUntil': 'Pembatalan gratis hingga {date}',
  'bookingDetails.total': 'Total:',
  'reservationDetail.loading': 'Memuat pemesanan Anda…',
  'reservationDetail.noReference': 'Tidak ada referensi pemesanan yang diberikan.',
  'reservationDetail.loadError': 'Tidak dapat memuat detail reservasi.',
  'site.footer.brand': 'BookYourStay',
  'common.loadingLocations': 'Memuat lokasi…',
  'common.couldNotLoadLocations': 'Tidak dapat memuat lokasi',
  'common.searchLocationPlaceholder': 'Cari negara, kota, atau properti',
  'common.collapse': 'Ciutkan',
  'common.expand': 'Kembangkan',
  'map.loadingGoogle': 'Memuat Google Map…',
  'map.errorGoogle': 'Gagal memuat Google Maps',
  'map.errorMap': 'Gagal memuat peta.',
  'map.greatLocation': 'Lokasi bagus',
  'home.trust.secureBooking': 'Pemesanan Aman',
  'home.trust.secureBookingDesc': 'Informasi Anda aman bersama kami.',
  'home.trust.bestPrice': 'Jaminan Harga Terbaik',
  'home.trust.bestPriceDesc': 'Menemukan harga lebih rendah? Kami akan menyamakannya.',
  'home.trust.localSupport': 'Dukungan 24/7',
  'home.trust.localSupportDesc': 'Kami siap membantu kapan saja.',
  'home.trust.flexibleBooking': 'Opsi Fleksibel',
  'home.trust.flexibleBookingDesc': 'Pembatalan gratis untuk tarif tertentu.',
  'promotion.memberPromo': 'Promo Anggota',
  'promotion.save': 'Hemat',
  'property.memberRate': 'Tarif Anggota',
  'property.hideAmenities': 'Sembunyikan fasilitas',
  'property.showAllAmenities': 'Tampilkan semua fasilitas',
  'property.chooseRatePromo':
    'Pilih tarif yang Anda sukai - Tarif anggota menawarkan hemat eksklusif!',
  'roomRate.stepChooseStay': '__I18N_PENDING__:Choose your stay',
  'roomRate.stepCheckout': '__I18N_PENDING__:Checkout',
  'roomRate.stepConfirmation': '__I18N_PENDING__:Confirmation',
  'roomRate.membersSaveUpTo': '__I18N_PENDING__:Members save up to {percent}%',
  'roomRate.membersSaveMore': '__I18N_PENDING__:Members save more',
  'roomRate.memberSignInHint':
    '__I18N_PENDING__:Sign in or join free during checkout to unlock member rates.',
  'roomRate.from': '__I18N_PENDING__:FROM',
  'roomRate.perNightSuffix': '__I18N_PENDING__:/ night',
  'roomRate.nonMemberFrom': '__I18N_PENDING__:Non-member rate from {price}',
  'roomRate.taxesIncluded': '__I18N_PENDING__:Rates include taxes & fees',
  'roomRate.taxesExcluded': '__I18N_PENDING__:Rates exclude taxes & fees',
  'roomRate.inclTaxes': '__I18N_PENDING__:incl. taxes & fees',
  'roomRate.exclTaxes': '__I18N_PENDING__:excl. taxes & fees',
  'roomRate.includesTaxes': '__I18N_PENDING__:Includes taxes and fees',
  'roomRate.excludesTaxes': '__I18N_PENDING__:Excludes taxes and fees',
  'roomRate.bookNow': '__I18N_PENDING__:Book now',
  'roomRate.selectRate': '__I18N_PENDING__:Select this rate',
  'roomRate.bestValue': '__I18N_PENDING__:Best Value',
  'roomRate.onlyLeftAtPrice': '__I18N_PENDING__:Only {count} left at this price',
  'roomRate.fullDetails': '__I18N_PENDING__:Full room details',
  'roomRate.loadMoreRates': '__I18N_PENDING__:Load more rates',
  'roomRate.showLessRates': '__I18N_PENDING__:Show less rates',
  'roomRate.vsNonMemberTotal': '__I18N_PENDING__:vs non-member total of {total}',
  'roomRate.youSave': '__I18N_PENDING__:You save {amount} ({percent}% off)',
  'roomRate.totalForNights': '__I18N_PENDING__:{total} total • {nights} nights',
  'roomRate.nightTimes': '__I18N_PENDING__:{nights} nights × {perNight}',
  'roomRate.totalLine': '__I18N_PENDING__:{total} total • {taxNote}',
  'roomRate.notMemberYet':
    '__I18N_PENDING__:Not a member yet? Join during checkout — the member price still applies.',
  'roomRate.promoApplied': '__I18N_PENDING__:Promo {code} applied',
  'roomRate.promotions': '__I18N_PENDING__:Promotions',
  'roomRate.promoSaveSuffix': '__I18N_PENDING__:Save - {percent}%',
  'roomRate.promoSaveAmountSuffix': '__I18N_PENDING__:Save - {amount}',
  'roomRate.promoStayPaySuffix': '__I18N_PENDING__:Stay {stayNights} nights, pay for {payNights}',
  'roomRate.promoEarlyBirdSuffix': '__I18N_PENDING__:Save - {percent}% when booked early',
  'roomRate.promoLastMinuteSuffix': '__I18N_PENDING__:Save - {percent}% for last-minute stays',
  'roomRate.promoLongStaySuffix': '__I18N_PENDING__:Save - {percent}% on longer stays',
  'roomRate.promoFixedRateSuffix': '__I18N_PENDING__:Special rate — {rate} per night',
  'roomRate.memberLocked': '__I18N_PENDING__:Member-only promotion',
  'roomRate.memberUnlockTitle': '__I18N_PENDING__:Sign in or join to unlock',
  'roomRate.memberUnlockSaving': '__I18N_PENDING__:member rates and save {amount} ({percent}%)',
  'roomRate.memberRateIncludes': '__I18N_PENDING__:Member rate includes',
  'roomRate.memberBenefitRatesTitle': '__I18N_PENDING__:Up to {percent}% lower rates',
  'roomRate.memberBenefitRatesBody':
    '__I18N_PENDING__:Unlock member-only promotions like {promotions}.',
  'roomRate.memberBenefitRatesBodyGeneric': '__I18N_PENDING__:Unlock member-only promotions.',
  'roomRate.memberBenefitBenefitsTitle': '__I18N_PENDING__:Same great benefits',
  'roomRate.memberBenefitBenefitsBody':
    '__I18N_PENDING__:Free cancellation, flexible payment and all standard inclusions.',
  'roomRate.memberBenefitJoinTitle': '__I18N_PENDING__:Free to join',
  'roomRate.memberBenefitJoinBody':
    '__I18N_PENDING__:Create an account in seconds during checkout.',
  'roomRate.joinFree': '__I18N_PENDING__:Join free',
  'roomRate.joinFreeCta': '__I18N_PENDING__:Sign in or join free',
  'roomRate.alreadyMember': '__I18N_PENDING__:Already a member?',
  'roomRate.alreadyMemberHint': '__I18N_PENDING__:Sign in to see your member rates applied',
  'roomRate.viewOtherRooms': '__I18N_PENDING__:View other room types',
  'roomRate.view': '__I18N_PENDING__:View',
  'roomRate.freeCancelUntil': '__I18N_PENDING__:Free cancellation until {date}',
  'roomRate.upsell': '__I18N_PENDING__:Recommended alternative',
  'roomRate.roomsIncluded': '__I18N_PENDING__:{count} rooms included',
  'roomRate.nightlyBreakdown': '__I18N_PENDING__:Night-by-night price',
  'roomRate.previousRate': '__I18N_PENDING__:Previous rate',
  'roomRate.nextRate': '__I18N_PENDING__:Next rate',
  'card.discount': '-Diskon {percent}%',
  'gallery.imageAlt': '{title} tampilan {current} dari {total}',
  'gallery.thumbnailAlt': 'Lihat tampilan {current} dari {total}',
  'gallery.previewAlt': 'Pratinjau {title}',
  'detail.night_one': 'malam',
  'detail.night_other': 'malam',
  'detail.adult_one': 'dewasa',
  'detail.adult_other': 'dewasa',
  'detail.child_one': 'anak',
  'detail.child_other': 'anak',
  'detail.infant_one': 'bayi',
  'detail.infant_other': 'bayi',
} as const;
